import { render, staticRenderFns } from "./ArchivePositionDialog.vue?vue&type=template&id=6b9496f1"
import script from "./ArchivePositionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivePositionDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports